/**
 * LE CACHE DES SURFACES PARESSEUSES d'App Canvas, pur (sans React) pour etre
 * prouve (`tests/app-canvas.test.mjs`).
 *
 * DEUX EXIGENCES QUI TIRENT EN SENS CONTRAIRE :
 *
 *  - UNE SURFACE PAR APP, creee hors du rendu. `lazy()` appele dans le
 *    composant fabriquerait un composant NEUF a chaque rendu : React demonterait
 *    la surface a chaque frappe dans la recherche, et un moteur tiers (un
 *    tableau blanc, une carte mentale) perdrait tout son etat ;
 *  - MAIS PAS POUR TOUJOURS. `lazy()` garde en memoire la promesse de son
 *    import, y compris REJETEE : un morceau qui n'arrive pas au premier essai
 *    (reseau coupe, deploiement entre deux) laissait la zone 5 en erreur
 *    jusqu'au F5. Un nouvel ESSAI (le bouton « Reessayer » du filet) fabrique
 *    donc une surface neuve, qui relance l'import.
 *
 * La table est faible : une app qui disparait emporte son entree.
 */
export function creerCacheDeSurfaces<C>(): (clef: object, essai: number, fabriquer: () => C) => C {
  const table = new WeakMap<object, { essai: number; surface: C }>();
  return (clef, essai, fabriquer) => {
    const connue = table.get(clef);
    if (connue !== undefined && connue.essai === essai) return connue.surface;
    const surface = fabriquer();
    table.set(clef, { essai, surface });
    return surface;
  };
}
